export default (img, tw = 320, th = 200, size = 1) => {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    canvas.width = tw;
    canvas.height = th;
    let w = img.width;
    let h = img.height;
    let dw = tw / w; //canvas与图片的宽高比
    let dh = th / h;
    // 裁剪图片中间部分
    if ((w > tw && h > th) || (w < tw && h < th)) {
        if (dw > dh) {
            ctx.drawImage(img, 0, (h - th / dw) / 2, w, th / dw, 0, 0, tw, th);
        } else {
            ctx.drawImage(img, (w - tw / dh) / 2, 0, tw / dh, h, 0, 0, tw, th);
        }
    }
    // 拉伸图片
    else {
        if (w < tw) {
            ctx.drawImage(img, 0, (h - th / dw) / 2, w, th / dw, 0, 0, tw, th);
        } else {
            ctx.drawImage(img, (w - tw / dh) / 2, 0, tw / dh, h, 0, 0, tw, th);
        }
    }

    //进行压缩
    return canvas.toDataURL('image/jpeg', size);
};



// WEBPACK FOOTER //
// ./src/server/compress.js